// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Left column – 50% */}
        <div className="footer-about">
          <div className="footer-logo">
            <img src="/logo.png" alt="Hot Setup" />
            <span>Hot Setup</span>
          </div>
          <p>
            The ultimate motorsport setup & data tracking app for club racers and track-day enthusiasts.
            Designed and built by <strong>Sasha Anis</strong> at Mountain Pass Performance.
          </p>
        </div>

        {/* Right columns */}
        <div className="footer-links">
          <div className="footer-column">
            <h4>Resources</h4>
            <ul>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/changelog">Changelog</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><a href="https://www.mountainpassperformance.com" target="_blank" rel="noopener noreferrer">
                Mountain Pass Performance
              </a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Contact</h4>
            <ul>
              <li><a href="#">Instagram</a></li>
              <li><a href="#">YouTube</a></li>
              <li><a href="mailto:hello@hotsetup.app">hello@hotsetup.app</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Mountain Pass Performance Inc. All Rights Reserved.</p>
      </div>
    </footer>
  );
}